import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

    constructor() {
    }

    public setItem(key, value) {
        localStorage.setItem(key, value);
    }

    public getItem(key) {
        return localStorage.getItem(key);
    }

    public clear() {
        let currentLang = localStorage.getItem('lang');
        localStorage.clear();
        localStorage.setItem('lang', currentLang);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/storage/storage.service.ts